import {Component, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {MatSelectChange} from "@angular/material/select";
import {WebSettings} from "@models";
import {SimConfigurationService} from "@services";

export interface DialogDataLanguageDialog extends MatDialogDataBaseInput {
	title: string;
	description: string;
	okText: string;
	cancelText: string;
	currentLanguage?: string;
}

export interface DialogDataLanguageDialogOutput extends MatDialogDataBaseOutput {
	language: string;
}

interface LanguageOption {
	code: string;
	name: string;
}

@Component({
	selector: "sim-change-language-dialog",
	templateUrl: "./change-language-dialog.component.html",
	styleUrl: "./change-language-dialog.component.scss",
	standalone: false,
})
export class ChangeLanguageDialogComponent
	extends BasicMaterialDialog<ChangeLanguageDialogComponent, DialogDataLanguageDialog, DialogDataLanguageDialogOutput>
	implements OnInit
{
	readonly settings: WebSettings = SimConfigurationService.settings;

	selectedLanguage: string = "";
	availableLanguages: LanguageOption[] = [
		{code: "en", name: "English"},
		{code: "de", name: "Deutsch"},
		{code: "fr", name: "Français"},
		{code: "pl", name: "Polski"},
		{code: "ru", name: "Русский"},
		{code: "es", name: "Español"},
		{code: "he", name: "עברית"},
	].filter((lang) => this.settings.visibleLanguages.includes(lang.code));

	constructor(_injector: Injector) {
		super(_injector);
	}

	ngOnInit(): void {
		this.selectedLanguage = this.data.currentLanguage || "en";
	}

	onLanguageChange(event: MatSelectChange): void {
		this.selectedLanguage = event.value;
	}
}
